export default {"src":"/app/_next/static/media/magnifying.6dee7687.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};